



















































































import { Component, Vue, Prop } from "vue-property-decorator";
import requestService from "@/service/requestService";
import { ElInput } from "element-ui/types/input";
import { MESSAGE } from "@/model/Message";

@Component
export default class KatashikiDialog extends Vue {

  reqService: requestService;
  appendToBody: string = "";
  hasData: boolean = false;
  loading: boolean = true;
  loadingText: string = MESSAGE.Loading;
  errorMessage: string = "";
  showDialog: boolean = false;

  $refs!: {
    searchKatashikiInput: ElInput;
    searchEngineKatashikiInput: ElInput;
    junseiTable?: any;
  };

  searchKatashiki: string = "";         // 検索条件のv-model用
  searchEngineKatashiki: string = "";   // 検索条件のv-model用
  searchKatashikiShiteiNo: string = "";
  searchRuibetsuKubunNo: string = "";
  searchedKatashiki: string = "";       // 前回検索時の検索条件
  searchedEngineKatashiki: string = ""; // 前回検索時の検索条件
  selectedKatashikiParams: any = null;  // 前回確定した型式情報

  nisseirenColumns: any = [];
  nisseirenTableData: any = [];
  selectedNisseirenCarModel: any = null;

  junseiColumns: any = [];
  junseiTableData: any = [];
  selectedJunseiCarModel: any = null;

  created() {
    this.reqService = new requestService();
    this.loading = false;

    let columns: any = [];
    columns.push({header: "車名", key: "modelNm"});
    columns.push({header: "型式", key: "katashiki"});
    columns.push({header: "原動機型式", key: "engineKatashiki"});
    columns.push({header: "過給機名称", key: "kakyuki"});
    this.$set(this, "nisseirenColumns", columns);

    columns = [];
    columns.push({header: "車名", key: "modelNm", width: 124});
    columns.push({header: "型式", key: "katashiki", width: 50});
    columns.push({header: "原動機型式", key: "engineKatashiki", width: 80});
    columns.push({header: "型式指定番号", key: "katashikiShiteiNo", width: 90});
    columns.push({header: "類別区分番号", key: "ruibetsuKubunNo", width: 90});
    columns.push({header: "生産開始", key: "syaryouShiki", width: 70});
    columns.push({header: "生産終了", key: "syaryouShuki", width: 70});
    this.$set(this, "junseiColumns", columns);
  }

  onOpen(
    katashiki: string,
    engineKatashiki: string,
    data?: any,
    selectedKatashikiParams?: any,
    katashikiShiteiNo: string = "",
    ruibetsuKubunNo: string = ""
  ) {
    if (katashiki) {
      this.$set(this, "searchKatashiki", katashiki);
    }
    if (engineKatashiki) {
      this.$set(this, "searchEngineKatashiki", engineKatashiki);
    }
    if (selectedKatashikiParams) {
      this.$set(this, "selectedKatashikiParams", selectedKatashikiParams);
    }
    this.searchKatashikiShiteiNo = katashikiShiteiNo;
    this.searchRuibetsuKubunNo = ruibetsuKubunNo;
    if (!data) {
      // 検索結果が渡されなかった場合は検索する（型式選択ボタン押下時など）
      this.onSubmitSearch();
    } else if (data.nisseirenKatashikiList || data.junseiKatashikiList) {
      // 検索結果が渡された場合はセットする
      let nisseirenTableData: any = [];
      let junseiTableData: any = [];
      data.nisseirenKatashikiList.forEach((item: any, index: number) => {
        nisseirenTableData.push({"selected": false, "params": item});
      });
      data.junseiKatashikiList.forEach((item: any, index: number) => {
        junseiTableData.push({"selected": false, "params": item});
      });
      this.$set(this, "nisseirenTableData", nisseirenTableData);
      this.updateJunseiColumnWidths(junseiTableData);
      this.$set(this, "junseiTableData", junseiTableData);
      this.$set(this, "hasData", true);
      this.adjustJunseiColumnWidths(junseiTableData);
    }

    this.showDialog = true;
    this.errorMessage = "";
  }

  onClose() {
    this.clearData();
    this.showDialog = false;
  }

  onDialog() {
    if (this.$refs.searchKatashikiInput) {
      this.$refs.searchKatashikiInput.select();
    }
  }

  // 型式検索実行
  onSubmitSearch() {
    if (this.searchKatashiki.length > 0 || (this.searchEngineKatashiki.length > 0)) {
      this.selectedNisseirenCarModel = null;
      this.selectedJunseiCarModel = null;
      this.searchedKatashiki = this.searchKatashiki;
      this.searchedEngineKatashiki = this.searchEngineKatashiki;
      this.reqService.getKatashikiList(
        this.searchKatashiki,
        this.searchEngineKatashiki,
        this.searchKatashikiShiteiNo,
        this.searchRuibetsuKubunNo
      )
      .then((data: any) => {
        const nisseirenTableData: any = [];
        const junseiTableData: any = [];
        data.nisseirenKatashikiList.forEach((item: any, index: number) => {
          nisseirenTableData.push({"selected": false, "params": item});
        });
        data.junseiKatashikiList.forEach((item: any, index: number) => {
          junseiTableData.push({"selected": false, "params": item});
        });
        this.$set(this, "nisseirenTableData", nisseirenTableData);
        this.updateJunseiColumnWidths(junseiTableData);
        this.$set(this, "junseiTableData", junseiTableData);
        this.$set(this, "hasData", true);
        this.adjustJunseiColumnWidths(junseiTableData);

        if (this.selectedKatashikiParams) {
          const nisseirenIndex = nisseirenTableData.findIndex((item: any) =>
            item.params.katashiki === this.selectedKatashikiParams.nisseirenKatashiki
            && item.params.engineKatashiki === this.selectedKatashikiParams.nisseirenEngineKatashiki
            && item.params.modelCd === this.selectedKatashikiParams.modelCd
            && item.params.kakyukiKbn === this.selectedKatashikiParams.kakyukiKbn
          );
          const junseiIndex = junseiTableData.findIndex((item: any) =>
            item.params.katashiki === this.selectedKatashikiParams.junseiKatashiki
            && item.params.engineKatashiki === this.selectedKatashikiParams.junseiEngineKatashiki
            && item.params.katashikiShiteiNo === this.selectedKatashikiParams.katashikiShiteiNo
            && item.params.ruibetsuKubunNo === this.selectedKatashikiParams.ruibetsuKubunNo
            && item.params.syaryouShiki === this.selectedKatashikiParams.syaryouShiki
            && item.params.syaryouShuki === this.selectedKatashikiParams.syaryouShuki
          );
          if (nisseirenIndex > -1) {
            this.selectNisseirenCarModel(this.nisseirenTableData[nisseirenIndex]);
          }
          if (junseiIndex > -1) {
            this.selectJunseiCarModel(this.junseiTableData[junseiIndex]);
          }
        }
      }).catch((error: any) => {
        if (error && error.status === 204) {
          this.$set(this, "nisseirenTableData", []);
          this.updateJunseiColumnWidths([]);
          this.$set(this, "junseiTableData", []);
          this.$set(this, "hasData", true);
          this.adjustJunseiColumnWidths([]);
          return;
        }
        throw error;
      });
    }
  }

  // 車名・型式・原動機型式の最長文字数に応じて、純正部品用テーブルの列幅を調整する。
  updateJunseiColumnWidths(junseiTableData: any[], totalWidth: number = 864) {
    const getMaxLength = (key: string) => junseiTableData.reduce((maxLength: number, item: any) => {
      const value = item.params[key] || "";
      return Math.max(maxLength, value.length);
    }, 0);
    const getAdditionalWidth = (length: number, minLength: number, maxLength: number, maxAdditionalWidth: number) => {
      const ratio = Math.max(0, Math.min(1, (length - minLength) / (maxLength - minLength)));
      return Math.round(maxAdditionalWidth * ratio);
    };
    const baseWidths = [124, 50, 80, 90, 90, 70, 70];
    const additionalWidths = [
      getAdditionalWidth(getMaxLength("modelNm"), 14, 65, 290),
      getAdditionalWidth(getMaxLength("katashiki"), 4, 8, 30),
      getAdditionalWidth(getMaxLength("engineKatashiki"), 8, 16, 60)
    ];
    const requestedAdditionalWidth = additionalWidths.reduce((total: number, width: number) => total + width, 0);
    const additionalWidthLimit = totalWidth - baseWidths.reduce((total: number, width: number) => total + width, 0);
    let widths: number[];

    if (requestedAdditionalWidth > additionalWidthLimit) {
      // 型式・原動機型式を優先し、残りを車名へ割り当てる。
      widths = [
        baseWidths[0] + additionalWidthLimit - additionalWidths[1] - additionalWidths[2],
        baseWidths[1] + additionalWidths[1],
        baseWidths[2] + additionalWidths[2],
        baseWidths[3],
        baseWidths[4],
        baseWidths[5],
        baseWidths[6]
      ];
    } else {
      widths = baseWidths.map((width: number, index: number) =>
        width + (additionalWidths[index] || 0)
      );
      const remainingWidth = additionalWidthLimit - requestedAdditionalWidth;
      const evenlyDistributedWidth = Math.floor(remainingWidth / widths.length);
      const remainderWidth = remainingWidth % widths.length;

      widths = widths.map((width: number, index: number) =>
        width + evenlyDistributedWidth + (index < remainderWidth ? 1 : 0)
      );
    }

    this.junseiColumns.forEach((column: any, index: number) => {
      this.$set(column, "width", widths[index]);
    });
  }

  // スクロールバー領域を除いた実表示幅に合わせて、列幅を再計算する。
  adjustJunseiColumnWidths(junseiTableData: any[]) {
    this.$nextTick(() => {
      const junseiTable = this.$refs.junseiTable;
      const bodyWrapper = junseiTable && junseiTable.$el.querySelector(".el-table__body-wrapper");
      if (!bodyWrapper || !bodyWrapper.clientWidth) {
        return;
      }
      this.updateJunseiColumnWidths(junseiTableData, bodyWrapper.clientWidth);
      this.$nextTick(() => junseiTable.doLayout());
    });
  }

  getKatashikiRowClassName({row}: any) {
    return row.selected ? "katashiki-selected" : "";
  }

  selectNisseirenCarModel(row: any) {
    this.nisseirenTableData.map((item: any) => {
      item.selected = false;
    });
    row.selected = true;
    this.selectedNisseirenCarModel = row.params;
  }

  selectJunseiCarModel(row: any) {
    this.junseiTableData.map((item: any) => {
      item.selected = false;
    });
    row.selected = true;
    this.selectedJunseiCarModel = row.params;
  }

  clearData() {
    this.searchKatashiki = "";
    this.searchEngineKatashiki = "";
    this.searchKatashikiShiteiNo = "";
    this.searchRuibetsuKubunNo = "";
    this.searchedKatashiki = "";
    this.searchedEngineKatashiki = "";
    this.nisseirenTableData = [];
    this.junseiTableData = [];
    this.selectedNisseirenCarModel = null;
    this.selectedJunseiCarModel = null;
    this.hasData = false;
  }

  // 型式・原動機型式を確定
  onConfirmKatashiki() {
    this.$emit("onKatashikiSelected", {
      nisseirenKatashiki: this.selectedNisseirenCarModel,
      junseiKatashiki: this.selectedJunseiCarModel,
      searchKatashiki: this.searchedKatashiki,
      searchEngineKatashiki: this.searchedEngineKatashiki
    });
    this.onClose();
  }

}
